import { render, staticRenderFns } from "./new4.vue?vue&type=template&id=637ab55a&scoped=true&"
import script from "./new4.vue?vue&type=script&lang=js&"
export * from "./new4.vue?vue&type=script&lang=js&"
import style0 from "./new4.vue?vue&type=style&index=0&id=637ab55a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ab55a",
  null
  
)

export default component.exports